import { Link } from 'react-router-dom'
import * as FiIcons from 'react-icons/fi'
import SafeIcon from '../common/SafeIcon'

function NotFound() {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8 text-center">
        <SafeIcon icon={FiIcons.FiAlertTriangle} className="mx-auto h-16 w-16 text-yellow-500" />
        <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">
          Η σελίδα δεν βρέθηκε
        </h2>
        <p className="mt-2 text-center text-sm text-gray-600">
          Η σελίδα που αναζητάτε δεν είναι διαθέσιμη ή δεν υπάρχει.
        </p>
        <div className="mt-5">
          <Link
            to="/"
            className="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
          >
            <SafeIcon icon={FiIcons.FiHome} className="mr-2" />
            Επιστροφή στην αρχική
          </Link>
        </div>
      </div>
    </div>
  )
}

export default NotFound